// This file will contain utility functions and constants for managing local storage related to the CoCo shopping basket.
import { ShoppingBasketCoCoScope } from '../../common/enums.js';

export const SHOPPING_BASKET_LOCAL_STORAGE_KEY_COCO = 'shopping-basket-coco';
export const SHOPPING_BASKET_LOCAL_STORAGE_KEY_COCO_EMPLOYEE = 'shopping-basket-coco-employee';

export const getShoppingBasketLocalStorageKeyCoCo = (scope: ShoppingBasketCoCoScope = ShoppingBasketCoCoScope.ADMIN) =>
  scope === ShoppingBasketCoCoScope.EMPLOYEE
    ? SHOPPING_BASKET_LOCAL_STORAGE_KEY_COCO_EMPLOYEE
    : SHOPPING_BASKET_LOCAL_STORAGE_KEY_COCO;

export const clearShoppingBasketFromLocalstorageCoCo = (
  scope: ShoppingBasketCoCoScope = ShoppingBasketCoCoScope.ADMIN
) => {
  localStorage.removeItem(getShoppingBasketLocalStorageKeyCoCo(scope));
};
